{
  "header": {
    "nav": {
      "services": "Serviços",
      "products": "Produtos",
      "security": "Segurança",
      "process": "Processo",
      "contact": "Contato"
    },
    "cta": "Fale com a gente",
    "brand_aria": "Niertech Solutions",
    "nav_aria": "Principal"
  },
  "hero": {
    "eyebrow": "Niertech Solutions",
    "title": "Desenvolvimento de software e consultoria em TI pra quem não aceita improviso.",
    "subtitle": "Entregamos sistemas sob medida, infraestrutura, segurança da informação e inteligência de dados — com a seriedade que projetos corporativos e do setor público exigem.",
    "cta_primary": "Falar com a equipe",
    "cta_secondary": "Nossos serviços",
    "stack_aria": "Stack"
  },
  "pillars": {
    "eyebrow": "Nossos serviços",
    "title": "Tecnologia do escopo ao deploy — tudo sob o mesmo teto.",
    "lead": "Somos uma empresa de tecnologia focada em oferecer soluções de alta qualidade pra empresas de diversos setores, com a confiabilidade que projetos sérios pedem.",
    "items": {
      "consulting": {
        "title": "Consultoria em TI",
        "body": "Assessoria estratégica pra otimizar processos, avaliar stack e direcionar decisões de tecnologia — do roadmap ao modelo de operação."
      },
      "dev": {
        "title": "Desenvolvimento de Software",
        "body": "Sistemas web e mobile sob medida com as stacks mais modernas. Do escopo funcional à entrega em produção, com documentação e testes."
      },
      "infra": {
        "title": "Infraestrutura de TI",
        "body": "Cloud computing, servidores, redes e provisionamento. Arquitetura escalável, monitoramento, backups e continuidade operacional."
      },
      "outsourcing": {
        "title": "Outsourcing de TI",
        "body": "Alocação de profissionais especializados pra projetos temporários ou de longa duração — com gestão técnica e SLA definidos."
      },
      "security": {
        "title": "Segurança da Informação",
        "body": "Proteção de dados em conformidade com a LGPD e normas internacionais. Políticas, auditorias, controle de acesso e resposta a incidentes."
      },
      "bi": {
        "title": "Business Intelligence",
        "body": "Dashboards, relatórios e integrações que transformam dados em insight estratégico. Indicadores operacionais acionáveis, não só gráficos."
      }
    }
  },
  "projects": {
    "eyebrow": "Produtos",
    "title": "Sistemas reais, em produção.",
    "lead": "Dois produtos principais com foco em setor público, apoiados por uma linha de aplicações corporativas que cobre CRM, comunicação e inteligência de dados.",
    "flagships": {
      "siplanp": {
        "tag": "Gestão Pública",
        "name": "SIPLANP",
        "subtitle": "Sistema de Planejamento & Gestão Pública",
        "desc": "Plataforma SaaS multi-tenant feita pra órgãos públicos substituírem planilhas e processos fragmentados. Kanban, formulários dinâmicos, chat interno, calendário e módulos verticais acoplados conforme a necessidade do edital.",
        "features": [
          "Multi-tenant com isolamento por cliente",
          "Controle de acesso por perfil e setor",
          "Módulos verticais plugáveis (engenharia, catálogo, fluxos)",
          "Exportação, auditoria e logs completos",
          "Interface web responsiva, sem instalação"
        ]
      },
      "ntnutri": {
        "tag": "Alimentação Escolar",
        "name": "NtNutri",
        "subtitle": "Gestão de Alimentação e Nutrição Escolar",
        "desc": "SaaS aderente à Resolução FNDE e à Lei do PNAE, pronto pra dispensa eletrônica e pregão. Planeja cardápios, calcula quantitativos, consolida pauta de licitação, controla estoque e gera a prestação de contas do FNDE sem re-digitação.",
        "features": [
          "Elaboração de cardápios com per capitas",
          "Cálculo automático de quantitativos",
          "Pauta de licitação consolidada",
          "Saldos de estoque e movimentação de alimentos",
          "30% agricultura familiar (Lei 11.947/2009)",
          "Exportação pro FNDE e relatórios gerenciais",
          "LGPD, perfis de acesso, transparência ativa"
        ]
      }
    },
    "products": {
      "nierbusyness": {
        "tag": "CRM Corporativo",
        "name": "NierBusyness",
        "desc": "CRM de ponta a ponta pra rotina comercial: captação e qualificação de leads, pipeline de vendas, propostas comerciais, contratos, assinatura digital e acompanhamento pós-venda. Integra com ERP, e-mail e WhatsApp pra centralizar todo o contato com o cliente num lugar só."
      },
      "yorwha": {
        "tag": "Inbox Multi-canal",
        "name": "Yorwha",
        "desc": "Plataforma multi-canal de mensageria pra PMEs: WhatsApp Business, Instagram Direct, Facebook Messenger, TikTok DM, SMS, e-mail e Telegram numa única caixa de entrada. Filas, RBAC, MFA (TOTP), templates, reações, anexos e chamadas. Conformidade GDPR/LGPD/CPRA — credenciais cifradas em repouso (AES-256-GCM), endpoints de exportação e exclusão de dados, políticas formais de incident response e access control."
      },
      "magnum": {
        "tag": "Analytics & Supervisório",
        "name": "Magnum",
        "desc": "Plataforma de analytics e supervisório em tempo real. Dashboards executivos, KPIs operacionais, alertas por regra, integração com fontes heterogêneas (SQL, APIs, CSV, IoT) e histórico consolidado pra decisão orientada a dado — do chão de fábrica à diretoria."
      }
    }
  },
  "security": {
    "eyebrow": "Segurança & Conformidade",
    "title": "Segurança não é checklist — é como a gente constrói.",
    "lead": "Todos os nossos sistemas seguem uma postura defensiva por padrão: dados cifrados em repouso, autenticação multifator, controle de acesso baseado em papéis e políticas formais de privacidade, retenção e resposta a incidentes. Engajamos com pesquisadores de segurança e mantemos um programa de divulgação responsável.",
    "items": {
      "encryption": {
        "title": "Cifragem em repouso e em trânsito",
        "body": "AES-256-GCM nas credenciais e dados sensíveis em coluna; TLS 1.3 fim-a-fim na borda. Chaves armazenadas em variáveis de ambiente, nunca no banco."
      },
      "mfa": {
        "title": "MFA + RBAC obrigatórios",
        "body": "TOTP (RFC 6238) obrigatório para owner, admin e developer. Controle de acesso por papel com princípio do menor privilégio, auditado anualmente."
      },
      "compliance": {
        "title": "GDPR / LGPD / CPRA aderente",
        "body": "Aviso de privacidade público, endpoints de exportação e exclusão de dados (direito do titular), retenção mínima por tipo de dado, deauth provider em até 24h."
      },
      "scans": {
        "title": "Varreduras contínuas",
        "body": "OWASP ZAP + Nuclei trimestrais e a cada release material. Dependabot ativo. SLAs claros: crítico 7 dias, alto 14 dias, médio 30 dias."
      },
      "disclosure": {
        "title": "Divulgação responsável",
        "body": "SECURITY.md público com janela de 90 dias para correção. Engajamos com pesquisadores externos e creditamos relatos válidos."
      },
      "researcher": {
        "title": "Pesquisadores de segurança no time",
        "body": "Temos pesquisadores de segurança internos. Cada sistema é olhado também pela ótica do atacante."
      }
    }
  },
  "process": {
    "eyebrow": "Como a gente trabalha",
    "title": "Processo previsível, entregas documentadas.",
    "lead": "Um fluxo pensado pra projetos corporativos e do setor público — auditável, confiável e sem surpresa em nenhuma fase.",
    "steps": {
      "01": {
        "title": "Entendimento",
        "body": "A gente escuta antes de propor. Mapeamos a operação, os objetivos do negócio e as restrições técnicas — incluindo exigências legais e de conformidade quando aplicável."
      },
      "02": {
        "title": "Planejamento técnico",
        "body": "Arquitetura da solução, definição de stack, plano de entregas e critérios de aceite. Sem caixa-preta — cada decisão técnica é documentada e justificada."
      },
      "03": {
        "title": "Desenvolvimento & homologação",
        "body": "Entregas incrementais, documentação técnica, testes automatizados e revisão contínua. Você acompanha o sistema evoluir do primeiro sprint até o deploy."
      },
      "04": {
        "title": "Operação, suporte & evolução",
        "body": "Hospedagem, monitoramento, suporte técnico e evolução contínua — com SLA claro durante toda a vigência do contrato."
      }
    }
  },
  "contact": {
    "eyebrow": "Contato",
    "title": "Vamos conversar sobre o seu projeto.",
    "lead": "Conte sobre sua empresa, o problema operacional ou a demanda do órgão — a gente volta com um parecer técnico inicial e um caminho claro pra entrega, sem compromisso.",
    "send_email": "Enviar e-mail",
    "view_github": "Ver no GitHub",
    "labels": {
      "email": "E-mail",
      "github": "GitHub",
      "address": "Endereço",
      "cnpj": "CNPJ"
    }
  },
  "footer": {
    "company_legal": "Niertech Tecnologias e Sistemas LTDA · CNPJ 64.745.677/0001-31",
    "copyright": "© {{year}} Niertech Solutions",
    "city": "São Paulo, Brasil"
  },
  "whatsapp": {
    "aria": "Fale conosco no WhatsApp",
    "message": "Olá! Gostaria de saber mais sobre os serviços da Niertech."
  },
  "lang_switcher": {
    "aria": "Selecionar idioma",
    "pt-BR": "Português",
    "en": "English",
    "es": "Español"
  }
}
